module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header class="content-header" data-state="view">\n    <div class="container-showroom-grid">\n        <div class="header-part header-part-view">\n            <h2>\n                '+
((__t=(view.getHeadline()))==null?'':_.escape(__t))+
'\n            </h2>\n            <h2 class="subline">\n                <span id="object-count">'+
((__t=(item.objectCount))==null?'':_.escape(__t))+
'</span>\n                '+
((__t=(view.getSubline()))==null?'':_.escape(__t))+
'\n            </h2>\n            <a href="http://www.colido.de" target="_blank"><span class="presented-by">Presented by</span><span class="presented-logo"><span>Colido</span>'+
((__t=( icon('logo') ))==null?'':__t)+
'</span></a>\n        </div>\n\n        ';
 if (view.getOption('showroomOptions')) { 
__p+='\n            <div class="showroom-options-region"></div>\n        ';
 } 
__p+='\n    </div>\n</header>';
}
return __p;
};